// removed by extract-text-webpack-plugin
module.exports = {"content":"content___ocM9x","closeIcon":"closeIcon___3KIyg","header":"header___12LLh","inputTitle":"inputTitle___boxXx","required":"required___1ndQm","tagContainer":"tagContainer___W0d-S","errorTxt":"errorTxt___JJYcE","tagDropdown":"tagDropdown___2KoqU","searchTag":"searchTag___7M0HO","upload":"upload___1tbOB","searchTagContainer":"searchTagContainer___3HA3X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.module.css
// module id = 211
// module chunks = 0